"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Persona/index"), exports);
//# sourceMappingURL=PersonaCoin.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/PersonaCoin.js
// module id = 954
// module chunks = 0